(() => {
  const popup = document.querySelector('[data-welcome-offer]');
  if (!popup) return;

  const storageKey = 'sakinahWelcome10DismissedAt';
  const cartAttemptKey = 'sakinahWelcome10CartAttempted';
  const fourteenDays = 14 * 24 * 60 * 60 * 1000;
  const forcePreview = new URLSearchParams(location.search).get('show_welcome_offer') === '1';
  const onBagPage = location.pathname.replace(/\/+$/, '') === '/cart';
  const query = new URLSearchParams(location.search);
  let lastFocused = null;

  const getStored = (storage, key) => {
    try { return window[storage].getItem(key); } catch { return null; }
  };
  const setStored = (storage, key, value) => {
    try { window[storage].setItem(key, value); } catch {}
  };

  if (onBagPage && Number(popup.dataset.cartItemCount) > 0 && Number(popup.dataset.cartDiscountCount) === 0 && !query.has('welcome_applied') && !getStored('sessionStorage', cartAttemptKey)) {
    setStored('sessionStorage', cartAttemptKey, '1');
    location.replace('/discount/WELCOME10?redirect=%2Fcart%3Fwelcome_applied%3D1');
    return;
  }

  const wasRecentlyDismissed = () => {
    const dismissedAt = Number(getStored('localStorage', storageKey) || 0);
    return dismissedAt > 0 && Date.now() - dismissedAt < fourteenDays;
  };
  const rememberDismissal = () => {
    if (!forcePreview) setStored('localStorage', storageKey, String(Date.now()));
  };
  const focusableElements = () => Array.from(popup.querySelectorAll('a[href], button:not([disabled])'));
  const openPopup = () => {
    lastFocused = document.activeElement;
    popup.hidden = false;
    requestAnimationFrame(() => popup.classList.add('is-visible'));
    document.documentElement.classList.add('welcome-offer-open');
    setTimeout(() => popup.querySelector('[data-copy-welcome-code]')?.focus(), 250);
  };
  const closePopup = () => {
    rememberDismissal();
    popup.classList.remove('is-visible');
    document.documentElement.classList.remove('welcome-offer-open');
    setTimeout(() => {
      popup.hidden = true;
      if (lastFocused instanceof HTMLElement) lastFocused.focus();
    }, 350);
  };

  popup.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', closePopup));
  popup.querySelector('[data-apply-welcome-offer]')?.addEventListener('click', rememberDismissal);
  popup.querySelector('[data-copy-welcome-code]')?.addEventListener('click', async event => {
    const label = event.currentTarget.querySelector('[data-copy-label]');
    try {
      await navigator.clipboard.writeText('WELCOME10');
      if (label) label.textContent = event.currentTarget.dataset.copySuccess;
    } catch {
      if (label) label.textContent = event.currentTarget.dataset.copyFallback;
    }
  });
  popup.addEventListener('keydown', event => {
    if (event.key === 'Escape') closePopup();
    if (event.key !== 'Tab') return;
    const focusable = focusableElements();
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  if (forcePreview || (!onBagPage && !wasRecentlyDismissed())) setTimeout(openPopup, forcePreview ? 500 : 4500);
})();
